import React from 'react';
import { Modal } from 'tea-component';
import { connect } from 'umi';
import AddEventForm from './AddEventForm';
import { useLocalText } from '@/pages/dashboard/utils/customHook';
import { ADD_EVENT_TEXT_LOCAL_CONFIG } from '../_config/constant';

import './index.scss';

function AddEventModal({ visible, onClose, gameCode, dispatch,editConfig, ...others }) {
  const localText = useLocalText(ADD_EVENT_TEXT_LOCAL_CONFIG);
  const {isEdit} = editConfig || {};

  return (
    <Modal
      size={550}
      className="dbd-add-event-modal"
      visible={visible}
      caption={isEdit ? localText?.editEvent: localText?.addEvent}
      onClose={onClose}
      maskClosable
      {...others}
    >
      <AddEventForm editConfig={editConfig} onClose={onClose} gameCode={gameCode} dispatch={dispatch} />
    </Modal>
  );
}

export default connect()(AddEventModal);
